import { ElementPreset } from "@/types/presets";
import { uiStore, documentStore } from "@/store/store";
import defensiveCopy from "@/util/defensive-copy";
import { getBuilderElementNameBySlug } from "@/lib/undo/snapshot-labels/document-store-property-change.utils";

export function applyPresetToActiveElementIfMatchingTypeOrCreateNewElementOfThatTypeAndThenApplyPreset(
  preset: ElementPreset
) {
  if (
    !uiStore.activeElement ||
    uiStore.activeElement.data.type !== preset.availableForType
  ) {
    documentStore.addElement({ elementSlug: preset.availableForType });
  }

  if (
    uiStore.activeElement &&
    uiStore.activeElement.data.type === preset.availableForType
  ) {
    documentStore.throttledPropertyChanged({
      elementId: uiStore.activeElement.id,
      path: "design",
      value: defensiveCopy(preset.designPropertiesData),
      meta: {
        snapshotLabel: `Apply preset "${
          preset.label
        }" to ${getBuilderElementNameBySlug(uiStore.activeElement.data.type)}`
      }
    });
  }
}
